import { apiRequest } from './client';
import type { UserPublic } from './types';

export interface LoginPayload {
  username: string;
  password: string;
  totp: string;
}

export async function login(payload: LoginPayload): Promise<UserPublic> {
  const data = await apiRequest<{ user: UserPublic }>('/auth/login', {
    method: 'POST',
    body: payload,
  });
  return data.user;
}

export async function logout(): Promise<void> {
  await apiRequest('/auth/logout', { method: 'POST' });
}

export async function me(): Promise<UserPublic> {
  return apiRequest<UserPublic>('/auth/me');
}
